module.exports = __webpack_public_path__ + "img/1.7b2993db.png";